var React = require('react');

function IconSpinner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"},React.createElement("animateTransform",{"type":"rotate","from":"0 50 50","to":"360 50 50","dur":"1s","repeatCount":"indefinite","attributeName":"transform","attributeType":"XML"})));
}

IconSpinner.defaultProps = {"className":"icon spinner","viewBox":"0 0 100 100","enableBackground":"new 0 0 0 0"};

module.exports = IconSpinner;

IconSpinner.default = IconSpinner;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-spinner.svg
// module id = 528
// module chunks = 0